import { createPortal } from "react-dom";
import { ReactNode, useLayoutEffect, useState } from "react";

/**
 * Renders children into a DOM node that exists outside
 * the hierarchy of the parent component.
 */
export function TooltipPortal({ children }: { children: ReactNode }) {
    const [tooltipRoot, setTooltipRoot] = useState<HTMLElement | null>(null);

    useLayoutEffect(() => {
        let div = document.getElementById("tooltip-root") as HTMLElement;
        if (!div) {
            // If there isn't a #tooltip-root, create one on the fly
            div = document.createElement("div");
            div.setAttribute("id", "tooltip-root");
            document.body.appendChild(div);
        }
        setTooltipRoot(div);
    }, []);

    if (!tooltipRoot) {
        return null;
    }

    return createPortal(children, tooltipRoot);
}
